import {
  CAROUSEL_EPISODES_LIMIT,
  LibraryUrlSearchParams,
  Routes,
} from '@/constants';
import { EpisodeCardVariants, Link } from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  LibraryCategoryEntity,
  selectUserAudienceRegions,
  selectUserCompliance,
  useAppSelector,
  useFetchCategoryEpisodesQuery,
} from '@/store';

import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

interface CategoryEpisodesCarouselProps {
  category: LibraryCategoryEntity;
}

export const CategoryEpisodesCarousel = ({
  category,
}: CategoryEpisodesCarouselProps) => {
  const audienceRegions = useAppSelector(selectUserAudienceRegions);
  const compliance = useAppSelector(selectUserCompliance);

  const {
    data: episodes = [],
    isUninitialized,
    isLoading,
  } = useFetchCategoryEpisodesQuery({
    libraryCategorySlug: category.slug,
    limit: CAROUSEL_EPISODES_LIMIT,
    compliance,
    audienceRegions,
    applyRelevanceBoost: true,
  });

  const searchParams = new URLSearchParams();
  searchParams.set(LibraryUrlSearchParams.CATEGORY_SLUG, category.slug);
  const libraryRouteWithCategoryPreselected = {
    pathname: Routes.LIBRARY,
    search: searchParams.toString(),
  };

  // Don't render the carousel if there are too few episodes
  if (!isLoading && !isUninitialized && episodes?.length < 5) {
    return null;
  }

  return (
    <EpisodeCardCarousel
      title={category.name}
      variant={EpisodeCardVariants.MEDIUM}
      ViewAllLink={() => (
        <Link to={libraryRouteWithCategoryPreselected}>View All</Link>
      )}
      uKey={`${category.name} Episodes`}
      episodes={episodes}
      isLoading={isLoading}
      referrer={{
        page: EVENT_CONSTANTS.PAGE.DISCOVER,
      }}
    />
  );
};
